/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useEffect, useRef, useState, useCallback } from 'react';
import { InputLabel, MenuItem, FormControl, Select, Box, Button, Container } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import ManageSearchIcon from '@mui/icons-material/ManageSearch'; //added on 23.09.2022
import UploadFileIcon from '@mui/icons-material/UploadFile'; //added on 01.04.2023
import IconButton from "@mui/material/IconButton";
import PrintIcon from '@mui/icons-material/Print';
import { Edit } from '@material-ui/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ToPrintPageAttrbute from '../components/ToPrintPageAttribute';
import ToPrintIndvPageAttrbute from '../components/ToPrintIndvPageAttribute';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { orange } from '@mui/material/colors';
import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

/*----------------------- Functional Component ---------------------*/
export default function PageAttribute() {
  const componentRef = useRef(null);
  const token = JSON.parse(localStorage.getItem('token')) 
  const navigate = useNavigate()
  const [rowtoreport, setRowToReportOnClick] = useState(0);

  const fetchIndvDataToPrint = async (courseid, coursegrp, studentid, studentname) => {
    // console.log(courseid, coursegrp, studentid, studentname)
    try {
      let p_scorelist = await axios.get(process.env.REACT_APP_API + `/PageEditAttribute/courseid/${courseid}/coursegrp/${coursegrp}/studentid/${studentid}/name/${studentname}?token=${token}`);
      // console.log("dataprint: ", p_scorelist.data)
      return p_scorelist;
    } catch (err) {
      if(err.response.status === 400) {
        toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
        localStorage.clear();
        navigate('/')
      } else {
        console.log("err: ", err.response.data)
      }
      console.log('PageAttrbute -> fetchdata to print failed -> err >>> ', err);
    }
  };

  /*-------------------- Hidding Datagrid column : added on 29.10.2022-----------------------*/
  const [access, setAccess] = useState(
    localStorage.getItem('Access') || ''
  );

  const fieldhidden = {
    'นทน.': true,
    'อาจารย์ประจำหมวดวิชา': true,
    'ปกครอง': false,
    'วัดผล': true,
    'กรรมวิธี': false,
    'ผอ.': true,
    'กรรมวิธีส่วนกลาง': false,
    'วัดผลส่วนกลาง': true,
  }

  /*-------------- added on 12042023 -----------------*/
  const btnuploadenable = {
    'นทน.': false,
    'อาจารย์ประจำหมวดวิชา': false,
    'ปกครอง': true,
    'วัดผล': false,
    'กรรมวิธี': true,
    'ผอ.': false,
    'กรรมวิธีส่วนกลาง': true,
    'วัดผลส่วนกลาง': false,
  }

  /*---------------- columns ----------------*/
  const columns = [
    {
      field: 'id',
      headerName: 'ลำดับ',
      width: 70,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => params.api.getRowIndex(params.row.persid) + 1,
    },
    {
      field: 'studentid',
      headerName: 'เลขประจำตัว',
      width: 110,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'name',
      headerName: 'ยศ-ชื่อ-สกุล',
      width: 150,
      headerAlign: 'center',
    },
    {
      field: 'fullscore',
      headerName: 'รวมคะแนนเต็ม',
      width: 130,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'score',
      headerName: 'คะแนนที่ได้',
      width: 130,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'averagescore',
      headerName: 'คะแนนเฉลี่ย',
      width: 130,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'edit',
      headerName: 'แก้ไข/ประเมินผลการเรียน',
      width: 180,
      headerAlign: 'center',
      align: 'center',
      hide: fieldhidden[access],
      renderCell: (params) => {
        return (
          <>
            <Link to='/PageEditAttribute' state={{ id: params.id }} >
              <Edit className="userListDate" />
            </Link>
          </>
        )
      }
    },
    {
      field: 'status',
      headerName: 'สถานะ',
      width: 70,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <div style={{
            fontWeight: 'bold',
            color: params.value ? '#018822' : '#A50000'
          }}>
            {params.value ? 'ผ่าน' : 'ไม่ผ่าน'}
          </div>
        )
      }
    },
    {
      field: 'print',
      headerName: 'พิมพ์',
      width: 70,
      headerAlign: 'center',
      align: 'center',
      hide: fieldhidden[access],
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={() => {
                fetchIndvDataToPrint(
                  params.row.CourseId,
                  params.row.CourseGrp,
                  params.row.studentid,
                  params.row.name
                )
                  .then(indvdata => {
                    setRowToReportOnClick(indvdata.data);
                    componentRef.current.handleprint();
                  })
                  .catch(err => {
                    console.log('PageAttrbute : rendercell -> fetchdata to print failed -> err >>> ', err);
                  });
              }}
            >
              <PrintIcon />
            </IconButton >
          </div>
        )
      }
    },
    {
      field: 'note',
      headerName: 'หมายเหตุ',
      width: 130,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <div style={{
            fontWeight: 'bold',
            color: params.value ? '#018822' : '#A50000'
          }}>
            {params.value ? 'เรียบร้อยแล้ว' : 'รอลงคะแนน'}
          </div>
        )
      }
    }
  ];

  /*------------------------- Initial useState ---------------------*/
  const [grpselected, setGrpSelect] = useState('');
  const [semselected, setSemSelect] = useState('');
  const [dropdownitems, setDropDownList] = useState([]);

  /*--------------- get coursegrp and seminar from PageEditAttribute ---------------*/
  const location = useLocation();
  const { backcoursegrp, backseminar } = location.state || {};

  /*--------------- Function used in this component ----------------*/
  const fetchdataToCreateList = async (_coursegrp, _seminar) => {
    // console.log("data SeminarList A: ", _seminar)
    const seminar = _seminar === undefined || _seminar === '' ? 0 : _seminar;
    // console.log("seminar: ", seminar)
    try {
      const courId = localStorage.getItem('AccessRights').substring(11, 14)
      let response = await axios.get(process.env.REACT_APP_API + `/PageAttribute/coursegrp/${_coursegrp}/seminar/${seminar}/${courId}?token=${token}`);

      if (response.data !== undefined) {
        setDataStorage(response.data.map((e) => Object.assign(e, { 'CourseId': courId, 'CourseGrp': _coursegrp, 'Seminar': seminar })));
        /*----------------- update on 06042023 (sort) -------------------------*/
        // let newarr = response.data.sort((a, b) => (a.studentid > b.studentid) ? 1 : ((b.studentid > a.studentid) ? -1 : 0));
        // newarr.map((e, i) => { e.id = (i + 1) });
        const sortSTU = response.data.sort((a, b) => {
          const numA = parseInt(a.studentid, 10);
          const numB = parseInt(b.studentid, 10);
          return numA - numB;}
        ); 
        const newarr = sortSTU.sort((a, b) => a.seminar - b.seminar); 
        setStudListTable(sortSTU);
      }
    } catch (err) {
      if(err.response.status === 400) {
        toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
        localStorage.clear();
        navigate('/')
      } else {
        console.log("err: ", err.response.data)
      }
    }
  };

  /*--------------- get data to create dropdown list ---------------*/
  useEffect(() => {
    (async () => {
      try {
        const courId = localStorage.getItem('AccessRights').substring(11, 14)
        let resdata = await axios.get(process.env.REACT_APP_API + `/PageAttribute/${courId}?token=${token}`);
        resdata.data.seminar.unshift('ทุกสัมมนา'); //---added on 26.09.2022
        // console.log("data SeminarList A: ", resdata.data)
        if (resdata.data !== undefined) {
          setDropDownList(resdata.data);
          // console.log("data1: ",resdata.data);
        }
      } catch (err) {
        if(err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          localStorage.clear();
          navigate('/')
        } else {
          console.log("err: ", err.response.data)
        }
      }
    })();
  }, [setDropDownList]);

  /*------------------------- make Student List ---------------------------*/
  const btnclick_ref = useRef(null);
  const [studlist, setStudListTable] = useState([]);

  const [coursegrp, setCourseGrp] = useState('');
  const handleCourseGrpSelect = (event, child) => {
    const arr = Object.values(child)[4].children.split(' ');
    setCourseGrp(parseInt(arr[1]));
    setGrpSelect(dropdownitems.coursegrp.findIndex((e) => e.includes(arr[1])));
  };

  const [seminar, setSeminar] = useState('');
  const handleSeminarSelect = (event, child) => {
    const arr = Object.values(child)[4].children.split(' ');
    setSeminar(event.target.value === 0 ? 0 : parseInt(arr[1]));
    setSemSelect(event.target.value === 0 ? 0 : dropdownitems.seminar.findIndex((e) => e.includes(arr[1])));
  };

  /*------------------- local storage ------------------------------*/
  const [datastorage, setDataStorage] = useState([]);
  localStorage.setItem('datastorage', JSON.stringify(datastorage));

  /*----------------------- Use Effect (Accept Button Clicked)-----------------------------*/
  useEffect(() => {
    const acceptBtnOnClick = () => {
      fetchdataToCreateList(coursegrp, seminar);
    };
    btnclick_ref.current = acceptBtnOnClick;
  }, [coursegrp, seminar, datastorage]);

  /*---------------------- Use Effect (Get back from PageEditAttribute) -------------------*/
  useEffect(() => {
    if (backcoursegrp !== undefined && dropdownitems.coursegrp !== undefined) {
      setGrpSelect(dropdownitems.coursegrp.findIndex((e) => e.includes(backcoursegrp)));
      setCourseGrp(backcoursegrp);
    }

    if (backseminar !== undefined && dropdownitems.seminar !== undefined) {
      //setSemSelect(dropdownitems.seminar.findIndex((e) => e.includes(backseminar)));
      setSemSelect(backseminar);
      setSeminar(backseminar);
    }

    fetchdataToCreateList(backcoursegrp, backseminar);

  }, [dropdownitems.coursegrp, dropdownitems.seminar]);

  const passStudListToPrintPage = () => {
    return studlist;
  }

  /*------------------------- Events : UploadBtnOnClick added on 06042023 ---------------------*/
  const toastid = useRef(null); //progress bar in toastify
  const user = localStorage.getItem('user');
  const UserId = JSON.parse(user)[0].PersId;

  const formatExcelLayout = (data) => {
    let newformat = {
      'CourseId': data[0],
      'PersId': data[3]?.toString(),
      'PerAttrScore': data.filter((e, i) => { if (i >= 28 && i <= 37) { return e } }),
      'InstructorId': UserId
    }

    //console.log(Object.values(newformat));
    return newformat;
  };

  /*-------------------- added on 02042023 ----------------------*/
  const addScoreFromExcelFile = async (xlsxscore) => {
    const token1 = localStorage.getItem('token')

    /*---------------- filter to get only completed data to upload -----------------*/
    let acceptlist = xlsxscore.filter(e => {
      return (
        e.PersId !== null &&
        e.PersId?.length === 10 &&
        e.PerAttrScore?.length === 10 &&
        Object.values(e).some(el => el != null) &&
        e.PerAttrScore.some(el => el != null) &&
        e.PerAttrScore.some(el => typeof el === 'number')
      );
    });

    /*---------------- filter to get only uncompleted data to edit -----------------*/
    let notacceptlist = xlsxscore.filter(e => {
      // console.log("e.PerAttrScore ",e.PerAttrScore)
      return (
        e.PersId === null ||
        e.PersId?.length !== 10 ||
        e.PerAttrScore?.length !== 10 ||
        Object.values(e).some(el => el == null) ||
        e.PerAttrScore.some(el => el == null) ||
        e.PerAttrScore.some(el => typeof el !== 'number')
        
      );
    });

    // if (acceptlist.length !== 0) {
    if (notacceptlist.length === 0) {
      let promise = new Promise((resolve, reject) => {
        acceptlist.map(async e => {
          try {
            let res = await axios.put(process.env.REACT_APP_API + `/PageEditAttribute/lastestscore?token=${token1}`, e);
            if (res.status === 200) {
              resolve(res.data);
            } else {
              reject(Error(res.statusText));
            }
          }
          catch (err) {
            if (err.response.status === 400) {
              toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
              localStorage.clear();
              navigate('/')
            }
            console.log('PageAttribute addScoreFromExcelFile failed >>> err : ', err);
          }
        });
        // acceptlist.map(async e => {
        //   let res = await axios.put(process.env.REACT_APP_API + `/PageEditAttribute/lastestscore?token=${token1}`, e);
        //   if (res.status === 200) {
        //     resolve(res.data);
        //   } else {
        //     reject(Error(res.statusText));
        //   }
        // });
      }
      );

      toast.promise(promise.then((data) => {
        console.log(data);
      }, (err) => {
        console.log(err);
      }), {
        pending: {
          render: 'กำลังอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูล',
          delay: undefined
        },
        success: {
          render() {
            let persidlist = [];
            notacceptlist.forEach(e => {persidlist.push(e.PersId)});
            return `อัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลเรียบร้อยแล้ว จำนวน ${acceptlist.length} ข้อมูล มีปัญหาจำนวน ${notacceptlist.length} ข้อมูล (เลขประจำตัวข้าราชการ : ${persidlist}) `;
          }
        },
        error: {
          render({ data }) {
            this.props.navigate('/');
            localStorage.clear();
            return (`ไม่สามารถอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลได้ เนื่องจาก ${data.message}`);
          }
        }
      }, {
        position: toast.POSITION.TOP_CENTER,
        delay: 3000
      });
    } else {
      toast.error('กรุณาตรวจสอบความถูกต้องของข้อมูลที่ต้องการอัพโหลดอีกครั้ง',
        { position: toast.POSITION.TOP_CENTER }
      );
    }
    // xlsxscore.map(async e => {
    //   try {
    //     await axios.put(process.env.REACT_APP_API + `/PageEditAttribute/lastestscore?token=${token1}`, e);
    //   }
    //   catch (err) {
    //     if (err.response.status === 400) {
    //       toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
    //       localStorage.clear();
    //       navigate('/')
    //     }
    //     console.log('PageAttribute addScoreFromExcelFile failed >>> err : ', err);
    //   }
    // });
  }

  const UploadBtnOnClick = useCallback((e) => {
    let formatxlsxlist = [];
    if (e.target.files.length) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetname = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetname];
        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false });
        if (reader.readyState === 2) {
          for (let indx = 2; indx < json.length; indx++) {
            formatxlsxlist.push(formatExcelLayout(json[indx]));
          }
          addScoreFromExcelFile(formatxlsxlist);
          // toast.promise(addScoreFromExcelFile(formatxlsxlist), {
          //   pending: {
          //     render: 'กำลังอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูล',
          //     delay: undefined
          //   },
          //   success: 'อัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลเรียบร้อยแล้ว',
          //   error: {
          //     render({ data }) {
          //       console.log('ไม่สามารถอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลได้ เนื่องจาก ', data.message);
          //     }
          //   }
          // }, {
          //   position: toast.POSITION.TOP_CENTER,
          //   delay: 500
          // });
        }
      }
    }
  });

  // const sortStudent = studlist.slice().sort((a, b) => a.Seminar - b.Seminar);

  /*------------------------------- Return ---------------------------*/
  return (
    <React.Fragment>
      <ToPrintIndvPageAttrbute
        ref={componentRef}
        dataToPrint={rowtoreport}
      />

      <div className="cotainerDetail">
        <p className="HeadTextMain">การวัด และประเมินคุณลักษณะส่วนบุคคล</p>
        <div className="DropdownSelectModel">
          <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
            <FormControl sx={{ m: 1, minWidth: 100 }}>
              <InputLabel
                htmlFor="grouped-select"
                sx={{
                  fontFamily: 'THSarabunNew',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                รุ่น
              </InputLabel>
              <Select
                value={grpselected}
                id="grouped-select"
                label="รุ่น"
                onChange={handleCourseGrpSelect}
                sx={{
                  fontFamily: 'THSarabunNew',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                {dropdownitems.coursegrp?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={index}
                      sx={{
                        fontFamily: 'THSarabunNew',
                        fontWeight: 'bold',
                        fontSize: 16,
                      }}
                    >
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 100 }}>
              <InputLabel
                htmlFor="seminar-select"
                sx={{
                  fontFamily: 'THSarabunNew',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                สัมมนา
              </InputLabel>
              <Select
                value={semselected}
                id="seminar-select"
                label="สัมมนา"
                onChange={handleSeminarSelect}
                sx={{
                  fontFamily: 'THSarabunNew',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                {dropdownitems.seminar?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={index}
                      sx={{
                        fontFamily: 'THSarabunNew',
                        fontWeight: 'bold',
                        fontSize: 16,
                      }}
                    >
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Button
              onClick={() => btnclick_ref.current()}
              variant="contained"
              sx={{
                minWidth: 100,
                minHeight: 55,
                m: 1,
                fontFamily: 'THSarabunNew',
                fontWeight: 'bold',
                fontSize: 16,
              }}
              startIcon={<ManageSearchIcon />}
            >
              ตกลง
            </Button>
            <input
              style={{ display: 'none' }}
              id='btn-fileupload'
              multiple
              type='file'
              onChange={(e) => UploadBtnOnClick(e)}
            />
            <label htmlFor='btn-fileupload'>
              {btnuploadenable[access] &&
                <Button
                  variant="contained"
                  sx={{
                    minWidth: 100,
                    minHeight: 55,
                    m: 1,
                    fontFamily: 'THSarabunNew',
                    fontWeight: 'bold',
                    fontSize: 16,
                    backgroundColor: orange['A700']
                  }}
                  startIcon={<UploadFileIcon />}
                  component='span'
                  onClick={() => {
                    setGrpSelect('');
                    setSemSelect('');
                    setStudListTable([]);
                  }}
                >
                  อัพโหลดคะแนน
                </Button>
              }
            </label>
          </Box>
        </div>
        <Container> {/*------- To Print ------*/}
          <ToPrintPageAttrbute
            grpAndSem={{
              coursegrp: coursegrp,
              seminar: seminar,
            }}
            Func={passStudListToPrintPage}
          />
          <div style={{ height: 700, width: '100%' }}>
            <DataGrid
              getRowId={(row) => row.persid}
              rows={studlist}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[5, 10]}
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}